// extracted by mini-css-extract-plugin
module.exports = {"container":"IdentityValidationContainer_container__-HOm7"};